import React from 'react';
import i18n from 'app/common/lib/i18n';
import templateConst from 'app/common/lib/templateConst';
import Toast from 'app/common/react/ui/Toast';
import withShowToast from 'app/common/lib/react/withShowToast';
import { HeaderHeight } from 'app/common/react/components/Header/Context/ContextConsumer';
import { track } from 'app/common/lib/react/analytics';
import { IconButton, Container, Box, Heading, Text, Button, TextField, Sticky } from 'gestalt';

const TOAST_DURATION = 3000;

class InAppLeadGenHero extends React.Component {
  state = {
    errorMessages: {
      name: null,
      email: null,
    },
  };

  submitLead(leadData) {
    track(PCONST.thrift.EventType.SUBMIT_ADVERTISER_LEAD, {
      component: PCONST.thrift.ComponentType.ADVERTISER_LEAD,
      lead_first_name: leadData.name,
      lead_email: leadData.email,
      lead_source: 'InAppLeadGenHero',
    });
  }

  validate({ name = '', email = '' }) {
    const errorMessages = {};
    let hasErrors = false;
    if (!name.trim().length) {
      errorMessages.name = i18n._("What's your name?", '[m10n]');
      hasErrors = true;
    }
    if (!email.trim().length || !email.includes('@')) {
      errorMessages.email = i18n._("What's your email?", '[m10n]');
      hasErrors = true;
    }
    this.setState({ errorMessages });
    return !hasErrors;
  }

  dismiss(evt) {
    evt.preventDefault();
    this.props.handleDismiss();
  }

  handleDismissClick = ({ event }) => {
    this.dismiss(event);
    track(PCONST.thrift.EventType.CLICK, {
      component: PCONST.thrift.ComponentType.PROPEL_LEAD_GEN_HERO,
      element: PCONST.thrift.ElementType.PROPEL_LEAD_GEN_DISMISS,
    });
  };

  handleSubmitClick = () => {
    const { handleComplete, showToast } = this.props;
    if (this.validate(this.state)) {
      this.submitLead(this.state);
      showToast(({ onHide }) => (
        <Toast
          duration={TOAST_DURATION}
          text={i18n._("Got it! We'll be in touch soon. Learn more", '[m10n]')}
          onHide={onHide}
          href={
            templateConst.settings.PARTNER_PROPEL_BLOG_POST +
            '?utm_source=pinterest&utm_medium=toast&utm_campaign=propel_submit'
          }
        />
      ));
      handleComplete();
    }
    track(PCONST.thrift.EventType.CLICK, {
      component: PCONST.thrift.ComponentType.PROPEL_LEAD_GEN_HERO,
      element: PCONST.thrift.ElementType.PROPEL_LEAD_GEN_SUBMIT,
    });
  };

  handleNameChange = ({ value: name }) => {
    this.setState({ name });
  };

  handleEmailChange = ({ value: email }) => {
    this.setState({ email });
  };

  render() {
    const { errorMessages } = this.state;

    return (
      <HeaderHeight>
        {(headerHeight) => (
          <Sticky dangerouslySetZIndex={{ __zIndex: 2 }} top={headerHeight}>
            <Box color="darkGray" flex="grow" position="relative">
              <Box position="absolute" top right deprecatedPadding={{ x: 3, y: 4 }}>
                <IconButton
                  accessibilityLabel={i18n._('Close Hero', '[m10n]')}
                  iconColor="white"
                  icon="cancel"
                  onClick={this.handleDismissClick}
                  size="sm"
                />
              </Box>
              <Container>
                <Box deprecatedPadding={{ y: 6, x: 4 }}>
                  <Box xs={{ column: 12 }}>
                    <Heading color="white" size="sm">
                      {i18n._('You’re invited to Pinterest Propel', '[m10n]')}
                    </Heading>
                  </Box>

                  <Box xs={{ column: 12 }} deprecatedMargin={{ top: 2, bottom: 3 }}>
                    <Text color="white" mdSize="xl" smSize="md" weight="bold">
                      {i18n._(
                        'Join today for phone support, custom Pins and expert tips for growing your business' +
                          ' — all for free.',
                        '[m10n]',
                      )}
                    </Text>
                  </Box>

                  <Box sm={{ display: 'flex' }}>
                    <Box xs={{ column: 12 }} sm={{ column: 5 }} deprecatedMargin={{ right: 1 }}>
                      <TextField
                        id="name"
                        placeholder={i18n._('Name', "[m10n] A prospective customer's name")}
                        type="email"
                        onChange={this.handleNameChange}
                        errorMessage={errorMessages.name}
                      />
                    </Box>
                    <Box xs={{ column: 12 }} sm={{ column: 5 }} deprecatedMargin={{ right: 1 }}>
                      <TextField
                        id="email"
                        placeholder={i18n._(
                          'Email',
                          "[m10n] A prospective customer's email address",
                        )}
                        type="email"
                        onChange={this.handleEmailChange}
                        errorMessage={errorMessages.email}
                      />
                    </Box>
                    <Box xs={{ column: 12 }} sm={{ column: 2 }}>
                      <Button
                        color="red"
                        inline
                        onClick={this.handleSubmitClick}
                        text={i18n._('Sign up', '[m10n]')}
                        type="submit"
                      />
                    </Box>
                  </Box>
                </Box>
              </Container>
            </Box>
          </Sticky>
        )}
      </HeaderHeight>
    );
  }
}

export default withShowToast(InAppLeadGenHero);
